import React from "react"
import { Tooltip } from "@material-ui/core"

type AIBlockTooltipProps = {
	children: React.ReactElement
}

const AIBlockTooltip: React.FC<AIBlockTooltipProps> = (props) => {
	return (
		<Tooltip
			title="Este bloco utiliza IA para deixar seu bot mais inteligente e versátil."
		>
			{props.children}
		</Tooltip>
	)
}

export default AIBlockTooltip
